import React, { useState, useRef, useEffect } from 'react';
import video from '../assets/wed_open.mp4';
import poster from '../assets/7.jpeg'; // Import the poster image
import './InvitationVideo.css';

const InvitationVideo = ({ onVideoEnd, onPlayMusic }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Set a timeout to allow the font to load before fading in
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 500); // Adjust this delay as needed
    return () => clearTimeout(timer);
  }, []);

  const handlePlay = () => {
    if (isClicked) return;

    setIsClicked(true);
    
    // Trigger the music to start playing from App.js
    if (onPlayMusic) {
        onPlayMusic();
    }

    if (videoRef.current) {
      videoRef.current.play();
      setTimeout(() => {
        setIsFading(true);
      }, 5000); // Start fading after 5 seconds
    }
  };

  const handleTransitionEnd = () => {
    if (isFading) {
      onVideoEnd();
    }
  };

  return (
    <div
      className={`video-container ${isFading ? 'fading' : ''} ${isReady ? 'ready' : ''} ${isClicked ? 'video-playing' : ''}`}
      onClick={handlePlay}
      onTransitionEnd={handleTransitionEnd}
    >
      <video
        ref={videoRef}
        src={video}
        muted
        playsInline
        preload="auto" /* Preload the entire video */
        poster={poster} /* Add a poster image */
        onContextMenu={(e) => e.preventDefault()} /* Disable right-click menu */
      />
      {!isClicked && <div className="play-button">Click to Open</div>}
    </div>
  );
};

export default InvitationVideo;
